import {
  provideKeycloak,
  createInterceptorCondition,
  withAutoRefreshToken,
  AutoRefreshTokenService,
  UserActivityService,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition
} from 'keycloak-angular';

// config
import { app } from './app.config';

export const provideKeycloakAngular = () =>
  provideKeycloak({
    config: {
      realm: app.clientRealm,
      url: app.urls.auth,
      clientId: app.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      redirectUri: app.urls.origin,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: ((1000 * 60) * app.config.timeOutMinutes)
      })
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: setConditions(),
      }
    ]
  });


function setConditions() {
  let response = [];

  const whitelist = [
    app.urls.auth,
    app.urls.contactManager,
    app.urls.eventManager,
    app.urls.reservationManager,
    app.urls.send,
    app.urls.stringer,
  ];

  for (const url of whitelist) {
    response.push(
      createInterceptorCondition<IncludeBearerTokenCondition>({
        // eslint-disable-next-line no-useless-escape
        urlPattern: new RegExp(`^${url}(\/.*)?$`, 'i')
      })
    )
  }

  return response;
}
